const featureItems = [
  {
    id: 1,
    icon: 'ri-4k-line',
    title: '全高清画质',
    desc: '所有影片均支持1080P高清播放，热门大片提供4K杜比视界版本，让你在家也能享受影院级视觉体验。极速CDN加速确保画面清晰流畅。',
  },
  {
    id: 2,
    icon: 'ri-flashlight-line',
    title: '极速播放引擎',
    desc: '自研播放引擎搭载智能预加载技术，即点即播零等待。自适应码率根据网络状况动态调整，Wi-Fi和移动网络下都能获得最佳播放效果。',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '纯净观影体验',
    desc: '无弹窗广告、无强制注册、无恶意跳转。陌陌影视坚持纯粹的观影体验，打开网站就能沉浸式享受电影世界，不受任何干扰。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            <i className="ri-vip-crown-line mr-1"></i>为什么选择我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">平台特色</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">陌陌影视致力于为每一位影迷提供最好的观影体验</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featureItems.map((item) => (
            <div key={item.id} className="bg-background-100 rounded-xl p-6 border border-secondary-200/50 text-center">
              <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mx-auto mb-4">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}